import { useRef, useState } from 'react'
import { useSearchStore } from '@/shared/store/useSearchStore'
import useFilteredBySearchChannels from '@/components/tv/hooks/useFilteredChannelsHook'
import { useSearchResult } from '@/features/VOD/hooks/useSearchResult'
import { channelType, vodContentType } from '@/shared/constants'
import { ChannelType } from '@/shared/types/appTypes'

export const usePopperSearchResultsLogic = (
    channels: Array<ChannelType>,
    query: string
) => {
    const [isShowMoreVod, setIsShowMoreVod] = useState(false)
    const [isShowMoreTV, setIsShowMoreTV] = useState(false)
    const [isShowMoreEpg, setIsShowMoreEpg] = useState(false)
    const { searchValue } = useSearchStore()

    const ref = useRef<HTMLDivElement | null>(null)

    const searchResults = useSearchResult(query)

    const vodSearchResults = searchResults.filter((channel) =>
        vodContentType.includes(channel.internalDeepLinkType)
    )
    const channelSearchResults = searchResults.filter(
        (channel) => channel.internalDeepLinkType === channelType
    )

    const { finallyFiltered } = useFilteredBySearchChannels(
        channels,
        searchValue
    )
    const searchChannelIds = channelSearchResults.map((result) =>
        result.internalDeepLinkContentId.toString()
    )

    const channelsFuturePlaying = channels.filter((channel) =>
        searchChannelIds.includes(channel.id.toString())
    )

    const container = {
        overflowX: 'hidden',
        width: '100vw',
        maxWidth: {
            xs: isShowMoreVod || isShowMoreTV ? '86vw' : '409px',
            lg: isShowMoreVod || isShowMoreTV ? '780px' : '409px',
        },
    }

    return {
        isShowMoreVod,
        isShowMoreTV,
        isShowMoreEpg,
        ref,
        setIsShowMoreVod,
        setIsShowMoreTV,
        setIsShowMoreEpg,
        finallyFiltered,
        channelsFuturePlaying,
        vodSearchResults,
        channelSearchResults,
        container,
    }
}
